/**
 * ViewerContent.js
 * Container for the actual comic/webtoon content.
 * Manages the layout difference between 'Comic Mode' and 'Scroll Mode'.
 */
export const ViewerContent = (isComicMode) => {
    const main = document.createElement('main');
    main.id = "viewer-main";

    if (isComicMode) {
        main.className = "w-full min-h-screen flex flex-col bg-black";
    } else {
        // Standard Webtoon Scroll Mode
        // Added pb-20 to ensure content isn't hidden behind fixed elements
        main.className = "flex-grow w-full max-w-3xl mx-auto bg-zinc-900 pb-20 webtoon-scroll-safe";
    }

    // [SECURITY] Anti-Download Transparent Overlay
    // [FIX] pointer-events-none: Allow clicks/scrolls to pass through to Viewer (Horizontal/Scroll)
    // Blocking is handled on the Main container level.
    // [FIX] Z-Index Adjustment: High enough to cover content, but lower than UI (BottomTab: 40)
    const protector = document.createElement('div');
    protector.className = "absolute inset-0 z-[30] bg-transparent pointer-events-none";
    // protector.oncontextmenu = ... (Moved to main)
    // protector.ondragstart = ... (Moved to main)
    main.appendChild(protector);

    // [FIX] Event Blocking at Container Level (Bubbling)
    main.oncontextmenu = (e) => {
        e.preventDefault();
        return false;
    };
    main.ondragstart = (e) => e.preventDefault();

    // Injection Point for VerticalViewer or HorizontalViewer
    const viewerHost = document.createElement('div');
    viewerHost.id = "viewer-host";
    main.appendChild(viewerHost);

    return { main, viewerHost };
};
